export default {
  create_title: 'Nieuw Partner API-account',
  edit_title: 'Account bewerken',
  form: {
    name: 'Accountnaam',
    name_placeholder: 'bijv. Acme POS-integratie',
    contact_email: 'Contact-e-mail',
    scope: 'Toegang tot restaurants',
    companies: 'Restaurants',
    scope_selected: 'Geselecteerde restaurants',
    scope_all: 'Alle restaurants',
    scope_all_help:
      'Sleutels op dit account hebben toegang tot elk restaurant van uw organisatie, ook later geregistreerde.',
    companies_placeholder: 'Selecteer restaurants',
    companies_help: 'Sleutels die op dit account zijn uitgegeven, kunnen alleen deze restaurants lezen en bewerken.',
    is_active: 'Actief',
    is_active_help: 'Inactieve accounts worden geweigerd bij authenticatie.',
  },
  buttons: {
    cancel: 'Annuleren',
    save: 'Opslaan',
    create: 'Aanmaken',
  },
  toasts: {
    created: 'Partner API-account aangemaakt.',
    updated: 'Account bijgewerkt.',
    error: 'Kan het account niet opslaan.',
  },
};
